/** @deprecated */
export const ACCOUNT_INACTIVE_ACTIVATION_MODAL = 'ACCOUNT_INACTIVE_ACTIVATION_MODAL';
export const ACCOUNT_PASSWORD_CHANGE_RECOMMENDATION_MODAL =
  'ACCOUNT_PASSWORD_CHANGE_RECOMMENDATION_MODAL';
export const ALERT_WITH_LINK_MODAL = 'ALERT_WITH_LINK_MODAL';
export const BASIC_MODAL = 'BASIC_MODAL';
export const BULK_REQUEST_CANCEL_MODAL = 'BULK_REQUEST_CANCEL_MODAL';
export const BULK_REQUEST_CREATE_MODAL = 'BULK_REQUEST_CREATE_MODAL';
export const BULK_REQUEST_DELETE_WARNING_MODAL = 'BULK_REQUEST_DELETE_WARNING_MODAL';
export const BULK_REQUEST_EXCEL_VALIDATION_ERROR_MODAL =
  'BULK_REQUEST_EXCEL_VALIDATION_ERROR_MODAL';
export const BULK_REQUEST_SEND_TEST_MODAL = 'BULK_REQUEST_SEND_TEST_MODAL';
export const BULK_REQUEST_SIGNING_EXPIRY_CHANGE_MODAL = 'BULK_REQUEST_SIGNING_EXPIRY_CHANGE_MODAL';
export const BULK_REQUEST_STARTED_ALERT = 'BULK_REQUEST_STARTED_ALERT';
export const BULK_REQUEST_TEMPLATE_PARTICIPANT_ALERT = 'BULK_REQUEST_TEMPLATE_PARTICIPANT_ALERT';
export const BULK_REQUEST_TERMINATE_WARNING_MODAL = 'BULK_REQUEST_TERMINATE_WARNING_MODAL';
export const BULK_REQUEST_UPDATE_TITLE_MODAL = 'BULK_REQUEST_UPDATE_TITLE_MODAL';
export const CONFIRM = 'CONFIRM';
export const CONTRACT_AGREEMENT_MODAL = 'CONTRACT_AGREEMENT_MODAL';
export const CONTRACT_LINK_START_CONFIRM_MODAL = 'CONTRACT_LINK_START_CONFIRM_MODAL';
export const CONTRACT_PROGRESS_CONFIRM_WITH_INFORMATION_LINK_MODAL =
  'CONTRACT_PROGRESS_CONFIRM_WITH_INFORMATION_LINK_MODAL';
export const CONTRACT_SETUP_START_CONFIRM_MODAL = 'CONTRACT_SETUP_START_CONFIRM_MODAL';
export const CUSTOM_EMAIL_SETTING_MODAL = 'CUSTOM_EMAIL_SETTING_MODAL';
export const CUSTOM_EMAIL_SETTING_LOGO_UPLOAD_MODAL = 'CUSTOM_EMAIL_SETTING_LOGO_UPLOAD_MODAL';
export const CUSTOM_EMAIL_SETTING_LOGO_IMAGE_CONSTRAINTS_ALERT_MODAL =
  'CUSTOM_EMAIL_SETTING_LOGO_IMAGE_CONSTRAINTS_ALERT_MODAL';
export const CUSTOM_EMAIL_SETTING_STYLE_RESET_CONFIRM_MODAL =
  'CUSTOM_EMAIL_SETTING_STYLE_RESET_CONFIRM_MODAL';
export const DEPOSIT_TRANSACTIONS_MODAL = 'DEPOSIT_TRANSACTIONS_MODAL';
export const DIGITAL_CERTIFICATE_GUIDE_CHECK_ERROR_MODAL =
  'DIGITAL_CERTIFICATE_GUIDE_CHECK_ERROR_MODAL';
export const DOCUMENT_BLOCK_MODAL = 'DOCUMENT_BLOCK_MODAL';
export const DOCUMENT_CANCEL_ALREADY_SIGNED_SIGNATURE_MODAL =
  'DOCUMENT_CANCEL_ALREADY_SIGNED_SIGNATURE_MODAL';
export const DOCUMENT_POLLING_ERROR_ALERT_MODAL = 'DOCUMENT_POLLING_ERROR_ALERT_MODAL';
export const DOCUMENT_REJECT_CONTRACT_MODAL = 'DOCUMENT_REJECT_CONTRACT_MODAL';
export const DOCUMENT_RESENT_SIGNING_ALERT_MODAL = 'DOCUMENT_RESENT_SIGNING_ALERT_MODAL';
export const DOCUMENT_TRANSMIT_MODAL = 'DOCUMENT_TRANSMIT_MODAL';
export const DOCUMENT_UNARCHIVE_MODAL = 'DOCUMENT_UNARCHIVE_MODAL';
export const DOCUMENT_UNBLOCK_MODAL = 'DOCUMENT_UNBLOCK_MODAL';
export const DOCUMENTS_ARCHIVE_MODAL = 'DOCUMENTS_ARCHIVE_MODAL';
export const DOCUMENTS_DIRECT_TO_CONTRACT_MODAL = 'DOCUMENTS_DIRECT_TO_CONTRACT_MODAL';
export const DOCUMENTS_MULTI_REQUEST_CANCEL_MODAL = 'DOCUMENTS_MULTI_REQUEST_CANCEL_MODAL';
export const DOCUMENTS_MULTI_RESEND_MODAL = 'DOCUMENTS_MULTI_RESEND_MODAL';
export const EDITOR_CONTRACT_SETUP_PREVIEW_MODAL = 'EDITOR_CONTRACT_SETUP_PREVIEW_MODAL';
export const EDITOR_EXIT_TO_MY_DOCUMENTS_MODAL = 'EDITOR_EXIT_TO_MY_DOCUMENTS_MODAL';
export const EDITOR_SINGLE_COMPLETE_MODAL = 'EDITOR_SINGLE_COMPLETE_MODAL';
export const EXIT_TO_EDITING_DOCUMENTS_MODAL = 'EXIT_TO_EDITING_DOCUMENTS_MODAL';
export const FILE_UPLOAD_ERROR_MODAL = 'FILE_UPLOAD_ERROR_MODAL';
export const FILE_OPEN_PASSWORD_PRECAUTIONS_MODAL = 'FILE_OPEN_PASSWORD_PRECAUTIONS_MODAL';
export const INVALID_PHONE_NUMBER_MODAL = 'INVALID_PHONE_NUMBER_MODAL';
export const KAKAO_RESEND_CONFIRM_MODAL = 'KAKAO_RESEND_CONFIRM_MODAL';
export const NAVER_LOGIN_RE_AGREE_MODAL = 'NAVER_LOGIN_RE_AGREE_MODAL';
export const NOTIFY_EMPTY_REQUESTER_FIELD_MODAL = 'NOTIFY_EMPTY_REQUESTER_FIELD_MODAL';
export const PAGE_EXIT_PREVENTION_MODAL = 'PAGE_EXIT_PREVENTION_MODAL';
export const PARTICIPANT_PROCESSING_FAILED_MODAL = 'PARTICIPANT_PROCESSING_FAILED_MODAL';
export const PARTICIPANT_PROCESSING_MODAL = 'PARTICIPANT_PROCESSING_MODAL';
export const ARCHIVED_DOCUMENTS_MODAL = 'ARCHIVED_DOCUMENTS_MODAL';
export const SENDING_TO_MAIL_MODAL = 'SENDING_TO_MAIL_MODAL';
export const SIGNATURE_PROGRESS_INFORMATION_MODAL = 'SIGNATURE_PROGRESS_INFORMATION_MODAL';
export const SIGNING_PROGRESS_REJECTION_MODAL = 'SIGNING_PROGRESS_REJECTION_MODAL';
export const SIGNING_REQUEST_ATTACHMENT_MODAL = 'SIGNING_REQUEST_ATTACHMENT_MODAL';
export const SINGLE_SIGNATURE_TEXT_FIELD_CHECK_MODAL = 'SINGLE_SIGNATURE_TEXT_FIELD_CHECK_MODAL';
export const TEMPLATE_EXIT_MODAL = 'TEMPLATE_EXIT_MODAL';
export const TEMPLATE_SAVE_CREATION_BEFORE_EXIT_MODAL = 'TEMPLATE_SAVE_CREATION_BEFORE_EXIT_MODAL';
export const TEMPLATE_SAVE_EDITION_BEFORE_EXIT_MODAL = 'TEMPLATE_SAVE_EDITION_BEFORE_EXIT_MODAL';
export const TRIAL_START_MODAL = 'TRIAL_START_MODAL';
export const WEBHOOK_CREATE_MODAL = 'WEBHOOK_CREATE_MODAL';
export const WELCOME_SURVEY_MODAL = 'WELCOME_SURVEY_MODAL';
export const WELCOME_CHOICE_MODAL = 'WELCOME_CHOICE_MODAL';
export const ACCOUNT_SUSPENDED_MODAL = 'ACCOUNT_SUSPENDED_MODAL';
export const LOGIN_FAILURE_MODAL = 'LOGIN_FAILURE_MODAL';
export const LOGIN_FAILURE_BLOCK_MODAL = 'LOGIN_FAILURE_BLOCK_MODAL';
